module.exports = __webpack_public_path__ + "static/media/average.84ebfe6c.png";